import { Collapse } from "@material-ui/core";
import React, { useEffect, useReducer, useState } from "react";
import { Carousel } from "react-bootstrap";
import translate from "../../../i18n/translate";
import { IDisplayNotification } from "../../../interfaces";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import NotificationView from "../../core/NotificationView/NotificationView";
import "../../core/NotificationView/NotificationView.scss";
import Toaster from "../Toaster/Toaster";
import { getCookieValue } from "./../../../cookieHelper";
import { useSelector } from "react-redux";

const getTimeFormat = (date: Date) => {
    let minutes: any = date.getMinutes();
    if (date.getSeconds() > 30) {
        minutes = minutes + 1;
    }
    let hrs = date.getHours();
    if (minutes === 60) {
        hrs = hrs + 1;
        minutes = "00";
    }
    let suffiex = "";
    if (hrs > 11) {
        hrs = hrs - 12;
        hrs = hrs === 0 ? 12 : hrs;
        suffiex = " PM";
    } else {
        suffiex = " AM";
    }
    return hrs + ":" + ("0" + minutes).slice(-2) + suffiex;
}
const NotificationBLock = (props: any) => {
    const [notification, setNotification] = useState([] as IDisplayNotification[]);
    const allInfo = useSelector((state: any) => state);

    const getDateFormat = (date: Date) => {
        const monthList = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return `${
            monthList[date.getMonth()]
            } ${date.getDate()},${date.getFullYear()}`;
    }

    const getDayCount = (startDate: Date, endDate: Date) => {
        return Math.floor((endDate.getTime() - startDate.getTime()) / 86400000) + 1;
    };

    const getNotificationMessage = (resp: any, userId: any) => {
        try {
            const displayNotificationList: IDisplayNotification[] = [];
            let notificationList: any = [];
            let hashKey : string ="";
                if(!!!allInfo.announcements.isLoading && !!!allInfo.announcements.isFailed && !!allInfo.announcements.data){
                    let response = null;
                    let removeJunk: string = "";
                    response = resp.data.getAnnouncements;
                    if (response) {
                        removeJunk = response.announcement
                            .replace(/^("\()/g, `"`)
                            .replace(/\);"$/g, `"`);
                        notificationList = JSON.parse(JSON.parse(removeJunk));
                        hashKey = response.hashKey;
                        sessionStorage.setItem("hashKey",hashKey);
                    }
                    notificationList.push({ "Type" : resp.data.twtNotification ? 5 : '' })
                    if(notificationList && notificationList.length > 0){
                            for (const notification of notificationList) {
                                const displayNotification: IDisplayNotification = {
                                    className: "",
                                    message: "",
                                    iconClass: "",
                                    link: "",
                                    type: "",
                                };
                                if (notification.hasOwnProperty("Type")) {
                                    switch (notification.Type) {
                                        case 2: {
                                            const tempEndDate = notification.Enddate.replace(/\/Date\(/g, "");
                                            const surveyEndDate = new Date(parseInt(tempEndDate, 10));
                                            const campId = notification.Args[0];
                                            const surveyObjId = notification.Args[1];
                                            const dayCount = getDayCount(new Date(), surveyEndDate);
                                            let surveyMessage :any  = dayCount > 1 ? <React.Fragment> {translate("notification_description_plural", {days : dayCount, date :getDateFormat(surveyEndDate) })} </React.Fragment> :  <React.Fragment> {translate("notification_description_singular", {days : dayCount, date :getDateFormat(surveyEndDate) })}</React.Fragment>;
                                            let surveyUrl = "";
                                            let surveyInterceptUrl = "";
                                            const userLang = getCookieValue("ulang");
                                            if (process.env.REACT_APP_CORP_ENDPOINT !== undefined && userLang !== undefined) {
                                                surveyUrl = encodeURIComponent(
                                                    `${process.env.REACT_APP_CORP_ENDPOINT}/templates/bin/template.asp?lang=${userLang.toUpperCase()}&ClassId=345&ObjectId=${surveyObjId}&Prop=CampaignId=${campId}`
                                                );
                                                surveyInterceptUrl = `${process.env.REACT_APP_CORP_ENDPOINT}/templates/bin/interceptpage/intercepthandler.asp?geedgeUid=${userId}&key=${
                                                    hashKey
                                                    }&redirect=${surveyUrl} `;
                                            }
                                            displayNotification.className = "success";
                                            displayNotification.iconClass = "geicon-alert-suggestion";
                                            displayNotification.message = surveyMessage;
                                            displayNotification.link = surveyInterceptUrl;
                                            displayNotification.type = "Survey Notice";
                                            displayNotificationList.push(displayNotification);
                                            break;
                                        }
                                        case 4: {
                                            const tempEndDate = notification.Enddate.replace(
                                                /\/Date\(/g,
                                                ""
                                            ).split("-");
                                            const endDate = new Date(parseInt(tempEndDate[0], 10));
                                            let maintenanceMessage : any = <React.Fragment> {translate("notification_maintenance_message", {date : getDateFormat(endDate), time : getTimeFormat(endDate)})}</React.Fragment>;
                                          
                                            if (notification.Message !== "") {
                                                maintenanceMessage = notification.Message;
                                            } 
                                            displayNotification.className = "error";
                                            displayNotification.iconClass = "alert";
                                            displayNotification.message = maintenanceMessage;
                                            displayNotification.type = "Maintenance Notice";
                                            displayNotificationList.push(displayNotification);
                                            break;
                                        }
                                        case 5: {
                                            let message = translate('twt_notification_message');
                                            displayNotification.className = "error";
                                            displayNotification.iconClass = "alert";
                                            displayNotification.message = message;
                                            displayNotification.type = 'twt';
                                            displayNotification.link = `${process.env.REACT_APP_TWT_URL}`;
                                            displayNotificationList.push(displayNotification);
                                            break;
                                        }
                                    }
                                }       
                            }
                    }
                    sessionStorage.setItem("displayNotificationList", JSON.stringify(displayNotificationList));
                    setNotification(displayNotificationList);
                    if (sessionStorage.getItem("notificationPopup") === null){
                        props.handleToggle(false, true, displayNotificationList.length);
                    } else if (sessionStorage.getItem("notificationPopup") === "true") {
                        props.handleToggle(true, false, 0);
                    } else if (sessionStorage.getItem("notificationPopup") === "false") {
                        props.handleToggle(false, false, 0);
                    }
            }
        } 
        catch (error: any) {
            toasterHandle(true, "error", "message_errorDefault");
            RollbarErrorTracking.logErrorInRollbar(error?.message, "error");
        }
    }

    const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
        toastOpen: false,
        toastSeverity: "error",
        toastMessageKey: "",
    });

    const handleToastOptionsDirect = (name: string, val: any) => {
        settoastOptions({ [name]: val });
    }
    const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
        handleToastOptionsDirect("toastSeverity", severity);
        handleToastOptionsDirect("toastMessageKey", messageKey);
        handleToastOptionsDirect("toastOpen", !!open);
    };
    const handleToggleNotification = (displayNotification: boolean, displayCount: boolean, length: number) => {
        props.handleToggle(displayNotification, displayCount, length);
    }

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;         
            if (!!!allInfo.announcements.isLoading && !!!allInfo.announcements.isFailed && !!allInfo.announcements.data) {
            getNotificationMessage(allInfo.announcements,userId);
            }
        }
      }, [allInfo.peopleInformation, allInfo.announcements]);

    return (<React.Fragment>
        <Toaster
            open={toastOptions.toastOpen}
            severity={toastOptions.toastSeverity}
            toasterClosed={toasterHandle}
            messageKey={toastOptions.toastMessageKey}
        />
        <Collapse in={props.showNotification} unmountOnExit={true}>
            {notification.length > 0 && (
                <Carousel fade={false} slide={false} controls={false}>
                    {notification.map(
                        // tslint:disable-next-line: no-shadowed-variable
                        (notify: IDisplayNotification, index: number) => {
                            return (
                                <Carousel.Item key={index}>
                                    <NotificationView
                                        key={index}
                                        displayNotification={{
                                            message: notify.message,
                                            iconClass: notify.iconClass,
                                            className: notify.className,
                                            type: notify.type,
                                            link: notify.link,
                                        }}
                                        handleToggle={handleToggleNotification}
                                        status={props.showNotification} 
                                        targetType='_self'
                                        />{" "}
                                        

                                </Carousel.Item>
                            );
                        }
                    )}
                </Carousel>
            )}
        </Collapse>
    </React.Fragment>
    )
}

export default NotificationBLock;